import { styled } from '@mui/material/styles';

// The builder's own layout breakpoint, kept from before it moved off styled-components.
const NARROW = '@media (max-width: 960px)';

// Title row above the form. Matches PreviewSplitMain's width so right-aligned
// header actions line up with the right edge of the input fields below.
export const PreviewSplitHeader = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  width: '65%',
  [NARROW]: { width: '100%' },
});

export const PreviewSplitLayout = styled('div')({
  display: 'flex',
  [NARROW]: { flexDirection: 'column' },
});

export const PreviewSplitMain = styled('div', {
  shouldForwardProp: prop => prop !== 'embedded',
})<{ embedded?: boolean }>(({ embedded }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: embedded ? '100%' : '65%',
  minWidth: 0,
  marginRight: embedded ? 0 : 80,
  marginTop: 20,
  marginBottom: 20,
  [NARROW]: { width: '100%', marginRight: 0 },
}));

export const PreviewSplitAside = styled('div')({
  position: 'fixed',
  right: '2.5%',
  top: 130,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [NARROW]: {
    position: 'relative',
    right: 'auto',
    top: 'auto',
    width: '100%',
    justifyContent: 'center',
    marginTop: 20,
  },
});
